import { styled } from "styled-components";
import { rgba } from "polished";
import { createTriangleStyles } from "../../utils/create-triangle-styles.es.js";
const MultiSliderHandleImpl = styled("div").attrs(({ left }) => ({
  style: { left }
}))(
  ({ theme }) => ({
    cursor: "grab",
    height: 20,
    outline: 0,
    position: "absolute",
    top: "50%",
    touchAction: "none",
    transform: "translate(-50%, -50%)",
    transformOrigin: "center",
    width: 32,
    pointerEvents: "auto",
    "&::before": {
      backgroundColor: "#fff",
      border: `2px solid ${theme.color.blue6}`,
      borderRadius: "50%",
      boxSizing: "border-box",
      content: JSON.stringify(""),
      height: 14,
      left: "50%",
      position: "absolute",
      top: "50%",
      transform: "translate(-50%, -50%)",
      width: 14
    },
    "&:focus::before": {
      boxShadow: `0 0 0 2px ${rgba(theme.color.blue6, 0.25)}`
    },
    "&:active": {
      cursor: "grabbing"
    }
  }),
  ({ disabled, theme }) => disabled ? {
    "&::before": {
      borderColor: theme.color.gray4
    },
    "&:focus::before": {
      boxShadow: "none"
    }
  } : void 0,
  ({ isMarker, theme }) => isMarker ? {
    "&::before": {
      border: `2px solid ${theme.color.gray4}`
    },
    "&:active, &:focus": {
      "&::before": {
        border: `2px solid ${theme.color.blue6}`
      }
    }
  } : void 0
);
const MultiSliderValueDisplay = styled("div")(({ theme }) => ({
  backgroundColor: "rgba(0, 0, 0, 0.85)",
  borderRadius: 4,
  boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.15)",
  color: "rgba(255, 255, 255, 0.85)",
  fontFamily: theme.fontFamily.default,
  fontSize: theme.fontSize.default,
  lineHeight: theme.lineHeight.default,
  padding: "4px 8px",
  position: "absolute",
  textAlign: "center",
  transform: "translate(-50%, -100%) translateY(-6px)",
  whiteSpace: "no-wrap",
  "&::before": createTriangleStyles({
    color: "rgba(0, 0, 0, 0.85)",
    justify: "center",
    placement: "top",
    size: 5
  })
}));
const MultiSliderHandleValueLabel = styled("div")({
  color: "rgba(255, 255, 255, 0.65)",
  whiteSpace: "pre"
});
export {
  MultiSliderHandleImpl,
  MultiSliderHandleValueLabel,
  MultiSliderValueDisplay
};
